import React, { useState } from 'react'
import "./NavMobile.css"

export default function NavMobile() {

    const [status, setStatus] = useState(false);

    const handleMenu = () => {
        setStatus(!status);
    }

  return (
    <div>

        <div className="navbar-mb">
            <div className="logo">
                <img width={"100px"} src="/assets/vitaly.webp" alt="" />
            </div>

            <div className="menu-mb">
            { status && <img onClick={handleMenu} width={"20px"} src="/assets/icons/x.png" alt="" />}
            { !status && <img onClick={handleMenu} width={"20px"} src="/assets/icons/menu-wider.png" alt="" />}
            </div>
            
        </div>

        <nav className='navigation-mb' 
        style={!status ?  {left: "-400px"} : {left: "0"}}>
            <div className="user-box">
                <img src="https://static.vecteezy.com/system/resources/thumbnails/000/439/863/small/Basic_Ui__28186_29.jpg" alt="" className="img-user" />
                <h6>Usuario Name</h6>
                <hr />
            </div>

            <div className="links">
                <div className="link">
                    <img src="" alt="" />
                    Lecheria
                </div>

                <div className="link">
                    <img src="" alt="" />
                    Explora
                </div>

                <div className="link">
                    <img src="" alt="" />
                    Categorias
                </div>
                
                <div className="link">
                    <img src="" alt="" />
                    Más
                </div>

                
            </div>
        </nav>
    </div>
  )
}
